import request from '@/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/lebo-system/param/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}
export const remove = (ids) => {
  return request({
    url: '/lebo-system/param/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/lebo-system/param/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/lebo-system/param/submit',
    method: 'post',
    data: row
  })
}
